<!--
  ~ Copyright (c) 2023-2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div class="container-fluid" id="bodycontainer-no-space">
  @if (!hasRoles) {
    <guest-info-panel></guest-info-panel>
  }
  @if (hasRoles) {
    <div id="homePageLabel">
      <br />
      <br />
      <br />
      <h1>
        Welcome to Electrical System & Component Interface
      </h1>
      <img width="50%" src="/assets/images/SplashScreen.png" alt="" aria-hidden="true"/>
    </div>
  }
</div>

